import { render } from "./StudentMarinePracticeView.vue?vue&type=template&id=f05cad12&scoped=true"
import script from "./StudentMarinePracticeView.vue?vue&type=script&lang=js"
export * from "./StudentMarinePracticeView.vue?vue&type=script&lang=js"

import "./StudentMarinePracticeView.vue?vue&type=style&index=0&id=f05cad12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05cad12"]])

export default __exports__